const UserPressedEmailUsDirectlyInFooter: string =
  "User_pressed_email_us_directly_in_footer";
export default UserPressedEmailUsDirectlyInFooter;
